import React from 'react';
import axios from 'axios';
import Header from './Header';
import Footer from './Footer';

const DonationPage = () => {
  const handleDonate = async () => {
    try {
      const amount = 10000; // ₹100.00 in paise
      const response = await axios.post('http://localhost:5000/api/create-order', {
        amount,
        currency: 'INR',
      });

      const { order } = response.data;

      const options = {
        key: 'your_razorpay_key_id',
        amount: order.amount,
        currency: order.currency,
        name: 'JAMIA NIDA-E-ISLAM ISLAMIC SCHOOL',
        description: 'Donation',
        order_id: order.id,
        handler: async (response) => {
          alert('Payment Successful');
          // Send payment response to your server for verification
          await axios.post('http://localhost:5000/api/payment-verification', response);
        },
        prefill: {
          name: 'Donor Name',
          email: 'donor@example.com',
        },
        theme: {
          color: '#1d9bf0',
        },
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();
    } catch (err) {
      console.error(err);
      alert('Something went wrong!');
    }
  };

  return (
    <>
      <Header />
      <div
        style={{
          textAlign: 'center',
          padding: '3rem 1rem',
          backgroundColor: '#f1f5f9',
          color: '#1a202c',
          fontFamily: 'Arial, sans-serif',
        }}
      >
        <h1
          style={{
            fontSize: '3rem',
            color: '#1d9bf0',
            fontWeight: 'bold',
            marginBottom: '1rem',
          }}
        >
          Support Our Cause
        </h1>
        <p
          style={{
            fontSize: '1.2rem',
            lineHeight: '1.8',
            maxWidth: '800px',
            margin: '0 auto 1.5rem',
          }}
        >
          At <strong>JAMIA NIDA-E-ISLAM ISLAMIC SCHOOL</strong>, education is more than just academics. We are committed
          to nurturing young minds while extending our reach to uplift underprivileged communities.
        </p>
        <p
          style={{
            fontSize: '1.2rem',
            lineHeight: '1.8',
            maxWidth: '800px',
            margin: '0 auto 2rem',
            textAlign: 'left',
          }}
        >
          <strong>Your donations directly support:</strong>
        </p>
        <ul
          style={{
            listStyleType: 'disc',
            margin: '0 auto 2rem',
            padding: '0 2rem',
            textAlign: 'left',
            maxWidth: '600px',
            fontSize: '1.2rem',
            lineHeight: '1.8',
          }}
        >
          <li>Subsidized or free education for children from low-income families.</li>
          <li>Distribution of essential items like clothes, blankets, and food to those in need.</li>
          <li>Workshops, skill training, and awareness programs for marginalized groups.</li>
        </ul>
        <p
          style={{
            fontSize: '1.2rem',
            lineHeight: '1.8',
            maxWidth: '800px',
            margin: '0 auto 2rem',
          }}
        >
          Every contribution—big or small—creates a ripple of change. Together, we can light up the lives of many and
          create a better future for those who need it most.
        </p>
        <button
          onClick={handleDonate}
          style={{
            backgroundColor: '#1d9bf0',
            color: 'white',
            border: 'none',
            padding: '1rem 3rem',
            fontSize: '1.2rem',
            cursor: 'pointer',
            borderRadius: '5px',
            fontWeight: 'bold',
            transition: 'transform 0.3s ease, background-color 0.3s ease',
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = '#0f77c0';
            e.target.style.transform = 'scale(1.05)';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = '#1d9bf0';
            e.target.style.transform = 'scale(1)';
          }}
        >
          Donate Now
        </button>
      </div>
      <Footer />
    </>
  );
};

export default DonationPage;
